export default __webpack_public_path__ + "static/media/hero-image-3.a14ca9e6.png";